<template>
  <div class="dialog-container" v-show="show">
    <div class="dialog-window" :class="className">
      <div class="box" v-show="this.type === 1"></div>
    </div>
  </div>
</template>

<script>

export default _extend({
  name: 'GlobalDialog',
  props: {
  },
  data() {
    return {
      type: 1,
      show: false,
      timer: null
    };
  },
  methods: {
    dialogShow(type) {
      this.type = type;
      this.show = true;
    },
    hide() {
      this.show = false;
    },
    toggle() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.show = false;
      }, 1500);
    }
  },
  computed: {
    className() {
      if (this.type === -1) {
        return 'toast_fail';
      } else if (this.type === 0) {
        return 'toast_timeout';
      } else {
        return '';
      }
    }
  }
});
</script>

<style lang="scss" scoped>
@import './GlobalDialog.scss';
</style>



// WEBPACK FOOTER //
// src/components/GlobalDialog/GlobalDialog.vue